/* eslint-disable @typescript-eslint/no-unused-vars */
import * as S from "../styles";

import { useEffect, useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

import AutoCompleteMult from "@/components/hookForms/autoCompleteMult";
import CheckBox from "@/components/hookForms/checkbox";
import CloseIcon from "@mui/icons-material/Close";
import IGenericResult from "@/interfaces/IGenericResult";
import IconButton from "@mui/material/IconButton";
import messages from "@/utils/messages";
import serviceConcessionaria from "@/services/serviceConcessionaria";
import serviceRelatorio from "@/services/serviceRelatorio";
import { statusFilterOptions } from "@/utils/constants";
import AutoComplete from "@/components/hookForms/autoComplete";
import DatePickerMui from "@/components/hookForms/datePicker";
import serviceUsina from "@/services/serviceUsina";
import { format } from "date-fns";
import { LoadingButton } from "@mui/lab";
import serviceRebateUsina from "@/services/serviceRebateUsina";

export interface IDialogProps {
    open: boolean;
    onClose?: any;
}

export default function CalculoRebate({ open, onClose }: IDialogProps) {
    const [usinaDataOptions, setUsinaDataOptions] = useState<IGenericResult[]>([]);
    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);
    const [statusDataOptions, setStatusDataOptions] = useState<any[]>([]);
    const [disabled, setDisabled] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const history = useHistory();

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            ConcessionariasIds: "",
            UsinasIds: "",
            statusId: "",
            dataInicioCicloFaturamento: "",
            dataFimCicloFaturamento: "",
        },
    });

    useEffect(() => {
        setUsinaData();
        setConcessionariaData();
        setStatusData();
    }, []);

    const setUsinaData = async () => {
        serviceUsina
            .getUsinas()
            .then((result) => {
                setUsinaDataOptions(result?.data);
            })
            .catch(() => {
                setUsinaDataOptions([]);
            });
    };

    const setStatusData = async () => {
        serviceRebateUsina
            .getStatus()
            .then((result) => {
                if (result) {
                    setStatusDataOptions(result.data);
                }
            })
            .catch(() => {
                setStatusDataOptions([]);
            });
    };

    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(result?.data);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setConcessionariaDataOptions([]);
            });
    };

    const onSubmit = (values: any) => {
        setDisabled(true);
        setLoading(true);

        let dataInicioCicloFaturamento = new Date(values.dataInicioCicloFaturamento);
        let dataFimCicloFaturamento = new Date(values.dataFimCicloFaturamento);

        const newValues = {
            ...values,
            relatorioTipoID: 21,
            ConcessionariasIds: values.ConcessionariasIds ? values.ConcessionariasIds.join(", ") : "",
            UsinasIds: values.UsinasIds ? values.UsinasIds.join(", ") : "",
            dataInicioCicloFaturamento: values?.dataInicioCicloFaturamento
                ? format(dataInicioCicloFaturamento, "yyyy-MM-01")
                : "",
            dataFimCicloFaturamento: values?.dataFimCicloFaturamento
                ? format(dataFimCicloFaturamento, "yyyy-MM-01")
                : "",
        };

        serviceRelatorio
            .getRelatorioCalculoRebate(newValues)
            .then((result) => {
                if (result) {
                    onClose();
                    toast.success(messages.reportSucess);
                }
            })
            .catch(() => {
                toast.error(messages.reportError);
            })
            .finally(() => {
                setDisabled(false);
                setLoading(false);
                if (newValues.redirecionar) {
                    history.push("/relatorios/listagemrelatorios");
                }
            });
    };

    return (
        <div>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    <S.Title>Gerar relatório: Cálculo do Rebate</S.Title>
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(onclose);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <S.Subtitles>Período de referência</S.Subtitles>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <DatePickerMui
                                    name="dataInicioCicloFaturamento"
                                    label="Inicio"
                                    format="MM/yyyy"
                                    view={["month", "year"]}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <DatePickerMui
                                    name="dataFimCicloFaturamento"
                                    label="Fim"
                                    format="MM/yyyy"
                                    view={["month", "year"]}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} md={12}>
                                <AutoCompleteMult
                                    name="UsinasIds"
                                    label="Usina"
                                    options={usinaDataOptions ?? []}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <AutoCompleteMult
                                    name="ConcessionariasIds"
                                    label="Concessionarias"
                                    options={concessionariaDataOptions ?? []}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <AutoComplete
                                    name="statusId"
                                    label="Status"
                                    options={
                                        statusDataOptions.map((data) => {
                                            return { value: data.rebateStatusID, label: data.descricao };
                                        }) ?? []
                                    }
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <CheckBox
                                    name="redirecionar"
                                    label="Redirecionar para a tela de relatório"
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            style={{ width: "159px", height: "44px" }}
                            onClick={() => {
                                reset();
                                onClose(onClose);
                            }}
                            color="warning"
                            variant="contained"
                        >
                            Cancelar
                        </Button>
                        <LoadingButton
                            loading={isLoading}
                            disabled={disabled}
                            style={{ width: "159px", height: "44px" }}
                            onClick={() => {}}
                            type="submit"
                            variant="contained"
                        >
                            Gerar
                        </LoadingButton>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );
}
